export default __webpack_public_path__ + "static/media/menu.c644a77e.svg";